import { Navigate } from "react-router-dom";
import { useAuth } from "./../components/authProvider";

const RequireAuthAdmin = ({ children }) => {
    const { authUserEx, authLoading } = useAuth();

    // 1- In loading state
    if (authLoading) return null;

    // 2- Authenticated
    if (authUserEx?.isSuperAdmin === true) return children;

    return <Navigate to="/profile" replace />;
};

export default RequireAuthAdmin